// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".trigger-log-grid[data-v-36d0389c] .message-column>.ag-cell-wrapper{top:0;transform:translate(0, 0)}", ""]);
// Exports
module.exports = exports;
